<template>
  <div style="text-align: left;height: 300px;width: 100%;">
    <Toolbar style="border: 1px solid #8091cc33" :editor="editorRef" :defaultConfig="toolbarConfig" :mode="mode" />
    <Editor
      style="min-height: 300px; overflow-y: hidden;border: 1px solid #8091cc33;border-bottom-left-radius: 6px;border-bottom-right-radius: 6px;"
      v-model="form[name]" :defaultConfig="editorConfig" :mode="mode" @onCreated="handleCreated" />
  </div>
</template>

<script>
import '@wangeditor/editor/dist/css/style.css';
import { onBeforeUnmount, shallowRef } from 'vue';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import { getUploadUrl } from '@/utils/upload';

export default {
  components: { Editor, Toolbar },
  props: {
    form: { type: Object },
    name: String,
  },
  setup() {
    const editorRef = shallowRef();
    const toolbarConfig = {};
    const editorConfig = {
      placeholder: '请输入内容...',
      MENU_CONF: {
        uploadImage: {
          server: getUploadUrl('htmlfile'),
          fieldName: 'file',
        },
      },
    };
    const handleCreated = (editor) => { editorRef.value = editor; };
    onBeforeUnmount(() => editorRef.value?.destroy());
    return { editorRef, toolbarConfig, editorConfig, handleCreated, mode: 'simple' };
  },
};
</script>